export const BiPpWp = 'WP';
export const BiPmGooglePay = 'googlePay';
export const BiPmApplePay = 'applePay';
export const BiShippingContact = 'shippingContact';
export const BiShippingMethod = 'shippingMethod';
export const BiOriginProduct = 'product';
export const BiOriginCart = 'cart';

export const longMulti = 100000;
